import Box from '@mui/material/Box';

import { NoData } from '../../../components/Illustrations/NoData';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { DataGrid } from '../../../components/DataGrid';
import { Loading } from '../../../components/Loading';

import { useInitialGridState } from '../hooks/useInitialGridState.hook';
import { useFindAllSectionTemplatesQuery } from '../hooks/useFindAllSectionTemplatesQuery.hook';

import { getColumns } from './get-columns';

export const SectionTemplatesList = () => {
  const { data, isSuccess } = useFindAllSectionTemplatesQuery();

  const { genericStatuses } = useReferencesContext();

  const { initialGridState } = useInitialGridState();

  if (isSuccess) {
    const { findAllSectionTemplates: sectionTemplates } = data;

    return !sectionTemplates.length ? (
      <NoData />
    ) : (
      <Box sx={{ flexGrow: 1, width: '100%', pt: 2 }}>
        <DataGrid
          columns={getColumns(genericStatuses)}
          initialState={initialGridState}
          rows={sectionTemplates}
        />
      </Box>
    );
  }

  return <Loading />;
};
